import React, { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import RecentJobs from "../components/RecentJobs";
import HowItWorks from "../components/HowItWorks";
import Trust from "../components/Trust";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [language, setLanguage] = useState("es");

  const toggleLanguage = () => {
    setLanguage(language === "es" ? "en" : "es");
  };

  return (
    <div className="min-h-screen bg-white">
      <Header language={language} toggleLanguage={toggleLanguage} />
      <Hero language={language} />
      <Services language={language} />
      <RecentJobs language={language} />
      <HowItWorks language={language} />
      <Trust language={language} />
      <FAQ language={language} />
      <Contact language={language} />
      <Footer language={language} />
    </div>
  );
};

export default LandingPage;
